import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { EntityLabel } from "~/components/Entity/EntityLabel";
import { getAllLabels } from "~/store/selectors/selector.labels";
import { sortCompare } from "~/utils/utils";
import LabelItems from "./LabelItems";

export const LabelTrigger = ({ labels }) => {
  const { t } = useTranslation();
  const allLabels = useSelector(getAllLabels);

  const labelsId = useMemo(() => {
    if (!labels.length) return [];
    return labels
      .map((id) => allLabels.get(`${id}`))
      .filter((label) => label !== undefined)
      .sort((a, b) => sortCompare(a.get("name").toLowerCase(), b.get("name").toLowerCase()))
      .map((label) => label?.id);
  }, [allLabels, labels]);

  if (!labelsId.length) {
    return (
      <EntityLabel
        className="entity-label tw-rounded tw-border tw-border-theme-700 tw-border-solid c-cooltip c-cooltip--top"
        data-tooltip={t("Add Labels")}
      >
        <Caption2
          className="entity-label-caption"
          weight="bold"
        >
          {t("LABEL")}
        </Caption2>
      </EntityLabel>
    );
  }
  return <LabelItems labels={labelsId} />;
};

LabelTrigger.propTypes = {
  labels: PropTypes.array.isRequired,
  className: PropTypes.string,
};
